import React from 'react'
import Fragment from '../common/fragment'


function FragmentAM(props) {
  return (
    <Fragment pos="m" {...props}>
      <p>
¿Con qué sueñan las usinas y los trenes?, ¿con los paraísos que les hemos
arrebatado?
      </p>
    </Fragment>
  )
}


export default FragmentAM
